/* tslint:disable */
/* eslint-disable */
/**
 * goal-wear
 * API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CalculateTotalRequest } from '../models';
// @ts-ignore
import type { CalculateTotalResponse } from '../models';
// @ts-ignore
import type { CreateStripePaymentIntent } from '../models';
// @ts-ignore
import type { GuestCreateStripePaymentIntent } from '../models';
// @ts-ignore
import type { PaymentIntentResponse } from '../models';
/**
 * PaymentsStripeApi - axios parameter creator
 * @export
 */
export const PaymentsStripeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CalculateTotalRequest} calculateTotalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsStripeCalculateTotalCreate: async (calculateTotalRequest: CalculateTotalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculateTotalRequest' is not null or undefined
            assertParamExists('paymentsStripeCalculateTotalCreate', 'calculateTotalRequest', calculateTotalRequest)
            const localVarPath = `/api/payments-stripe/calculate-total/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateTotalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStripePaymentIntent} createStripePaymentIntent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsStripeCreatePaymentIntentCreate: async (createStripePaymentIntent: CreateStripePaymentIntent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStripePaymentIntent' is not null or undefined
            assertParamExists('paymentsStripeCreatePaymentIntentCreate', 'createStripePaymentIntent', createStripePaymentIntent)
            const localVarPath = `/api/payments-stripe/create-payment-intent/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStripePaymentIntent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GuestCreateStripePaymentIntent} guestCreateStripePaymentIntent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsStripeGuestPaymentIntentCreate: async (guestCreateStripePaymentIntent: GuestCreateStripePaymentIntent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'guestCreateStripePaymentIntent' is not null or undefined
            assertParamExists('paymentsStripeGuestPaymentIntentCreate', 'guestCreateStripePaymentIntent', guestCreateStripePaymentIntent)
            const localVarPath = `/api/payments-stripe/guest-payment-intent/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestCreateStripePaymentIntent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsStripeWebhookCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/payments-stripe/webhook/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsStripeApi - functional programming interface
 * @export
 */
export const PaymentsStripeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsStripeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CalculateTotalRequest} calculateTotalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsStripeCalculateTotalCreate(calculateTotalRequest: CalculateTotalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateTotalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsStripeCalculateTotalCreate(calculateTotalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsStripeApi.paymentsStripeCalculateTotalCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateStripePaymentIntent} createStripePaymentIntent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsStripeCreatePaymentIntentCreate(createStripePaymentIntent: CreateStripePaymentIntent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentIntentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsStripeCreatePaymentIntentCreate(createStripePaymentIntent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsStripeApi.paymentsStripeCreatePaymentIntentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GuestCreateStripePaymentIntent} guestCreateStripePaymentIntent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsStripeGuestPaymentIntentCreate(guestCreateStripePaymentIntent: GuestCreateStripePaymentIntent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentIntentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsStripeGuestPaymentIntentCreate(guestCreateStripePaymentIntent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsStripeApi.paymentsStripeGuestPaymentIntentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsStripeWebhookCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsStripeWebhookCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsStripeApi.paymentsStripeWebhookCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsStripeApi - factory interface
 * @export
 */
export const PaymentsStripeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsStripeApiFp(configuration)
    return {
        /**
         * 
         * @param {PaymentsStripeApiPaymentsStripeCalculateTotalCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsStripeCalculateTotalCreate(requestParameters: PaymentsStripeApiPaymentsStripeCalculateTotalCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalculateTotalResponse> {
            return localVarFp.paymentsStripeCalculateTotalCreate(requestParameters.calculateTotalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentsStripeApiPaymentsStripeCreatePaymentIntentCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsStripeCreatePaymentIntentCreate(requestParameters: PaymentsStripeApiPaymentsStripeCreatePaymentIntentCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentIntentResponse> {
            return localVarFp.paymentsStripeCreatePaymentIntentCreate(requestParameters.createStripePaymentIntent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentsStripeApiPaymentsStripeGuestPaymentIntentCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsStripeGuestPaymentIntentCreate(requestParameters: PaymentsStripeApiPaymentsStripeGuestPaymentIntentCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentIntentResponse> {
            return localVarFp.paymentsStripeGuestPaymentIntentCreate(requestParameters.guestCreateStripePaymentIntent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsStripeWebhookCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentsStripeWebhookCreate(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentsStripeCalculateTotalCreate operation in PaymentsStripeApi.
 * @export
 * @interface PaymentsStripeApiPaymentsStripeCalculateTotalCreateRequest
 */
export interface PaymentsStripeApiPaymentsStripeCalculateTotalCreateRequest {
    /**
     * 
     * @type {CalculateTotalRequest}
     * @memberof PaymentsStripeApiPaymentsStripeCalculateTotalCreate
     */
    readonly calculateTotalRequest: CalculateTotalRequest
}

/**
 * Request parameters for paymentsStripeCreatePaymentIntentCreate operation in PaymentsStripeApi.
 * @export
 * @interface PaymentsStripeApiPaymentsStripeCreatePaymentIntentCreateRequest
 */
export interface PaymentsStripeApiPaymentsStripeCreatePaymentIntentCreateRequest {
    /**
     * 
     * @type {CreateStripePaymentIntent}
     * @memberof PaymentsStripeApiPaymentsStripeCreatePaymentIntentCreate
     */
    readonly createStripePaymentIntent: CreateStripePaymentIntent
}

/**
 * Request parameters for paymentsStripeGuestPaymentIntentCreate operation in PaymentsStripeApi.
 * @export
 * @interface PaymentsStripeApiPaymentsStripeGuestPaymentIntentCreateRequest
 */
export interface PaymentsStripeApiPaymentsStripeGuestPaymentIntentCreateRequest {
    /**
     * 
     * @type {GuestCreateStripePaymentIntent}
     * @memberof PaymentsStripeApiPaymentsStripeGuestPaymentIntentCreate
     */
    readonly guestCreateStripePaymentIntent: GuestCreateStripePaymentIntent
}

/**
 * PaymentsStripeApi - object-oriented interface
 * @export
 * @class PaymentsStripeApi
 * @extends {BaseAPI}
 */
export class PaymentsStripeApi extends BaseAPI {
    /**
     * 
     * @param {PaymentsStripeApiPaymentsStripeCalculateTotalCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsStripeApi
     */
    public paymentsStripeCalculateTotalCreate(requestParameters: PaymentsStripeApiPaymentsStripeCalculateTotalCreateRequest, options?: RawAxiosRequestConfig) {
        return PaymentsStripeApiFp(this.configuration).paymentsStripeCalculateTotalCreate(requestParameters.calculateTotalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentsStripeApiPaymentsStripeCreatePaymentIntentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsStripeApi
     */
    public paymentsStripeCreatePaymentIntentCreate(requestParameters: PaymentsStripeApiPaymentsStripeCreatePaymentIntentCreateRequest, options?: RawAxiosRequestConfig) {
        return PaymentsStripeApiFp(this.configuration).paymentsStripeCreatePaymentIntentCreate(requestParameters.createStripePaymentIntent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentsStripeApiPaymentsStripeGuestPaymentIntentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsStripeApi
     */
    public paymentsStripeGuestPaymentIntentCreate(requestParameters: PaymentsStripeApiPaymentsStripeGuestPaymentIntentCreateRequest, options?: RawAxiosRequestConfig) {
        return PaymentsStripeApiFp(this.configuration).paymentsStripeGuestPaymentIntentCreate(requestParameters.guestCreateStripePaymentIntent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsStripeApi
     */
    public paymentsStripeWebhookCreate(options?: RawAxiosRequestConfig) {
        return PaymentsStripeApiFp(this.configuration).paymentsStripeWebhookCreate(options).then((request) => request(this.axios, this.basePath));
    }
}

